import { subscriptionTypesMap } from '@/data/type-maps';
import { useAuthStore } from '@/stores/auth.ts';
import { useModal } from '@/composables/modal/modal';
import PlanLimitedModal from '@/modals/subscription/plan-limited-modal.vue';
export default {
    updated(el, binding) {
        restrict(el, binding);
    },
    beforeMount(el, binding) {
        restrict(el, binding);
    },
};
function restrict(el, binding) {
    const htmlEl = el;
    if (shouldRestrict(binding)) {
        el.addEventListener('click', (event) => {
            var _a, _b;
            event.stopImmediatePropagation();
            event.preventDefault();
            const instance = binding.instance;
            if ((_a = instance === null || instance === void 0 ? void 0 : instance.$) === null || _a === void 0 ? void 0 : _a.appContext) {
                useModal(instance.$.appContext, PlanLimitedModal, {
                    feature: (_b = binding.arg) !== null && _b !== void 0 ? _b : 'general',
                }).show();
            }
        }, { capture: true });
        el.classList.add('disabled');
        htmlEl.style.setProperty('cursor', 'pointer', 'important');
        htmlEl.style.setProperty('pointer-events', 'auto', 'important');
    }
    else {
        el.classList.remove('disabled');
        htmlEl.style.removeProperty('cursor');
        htmlEl.style.removeProperty('pointer-events');
    }
}
function shouldRestrict(binding) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const authStore = useAuthStore();
    if ((_a = authStore.company) === null || _a === void 0 ? void 0 : _a.archived_at) {
        return true;
    }
    if (binding.value === false) {
        return false;
    }
    if (authStore.user && ((_c = (_b = authStore.user) === null || _b === void 0 ? void 0 : _b.permissions) === null || _c === void 0 ? void 0 : _c.subscription.tag) === subscriptionTypesMap.free) {
        return true;
    }
    if ((binding === null || binding === void 0 ? void 0 : binding.arg) === 'waybill' && ((_e = (_d = authStore.user) === null || _d === void 0 ? void 0 : _d.permissions) === null || _e === void 0 ? void 0 : _e.subscription.tag) === subscriptionTypesMap.mini) {
        return true;
    }
    if ((binding === null || binding === void 0 ? void 0 : binding.arg) === 'work-act' && ((_g = (_f = authStore.user) === null || _f === void 0 ? void 0 : _f.permissions) === null || _g === void 0 ? void 0 : _g.subscription.tag) === subscriptionTypesMap.mini) {
        return true;
    }
    return Boolean(((_h = authStore.user) === null || _h === void 0 ? void 0 : _h.is_employee) && !authStore.user.permissions.subscription.employees);
}
